import firebase from "firebase/app";
import { clientCountersCollection } from "@/firebase";
import "firebase/functions";
import moment from "moment";

const state = {
  clientCounters: [],
  orderId: "",
};

const getters = {};

const actions = {
  getClientNextOrderId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      clientCountersCollection
        .where("client", "==", payload.client)
        .get()
        .then((querySnapshot) => {
          let realNextOrderId = "";

          if (querySnapshot.empty) {
            // če slučajno zapis v bazi še ne obstaja generiramo začetno id številko
            let getTimeStamp = firebase
              .functions()
              .httpsCallable("getTimeStamp");
            getTimeStamp({}).then((result) => {
              realNextOrderId = moment(result).format("YYYY-MM-1");
              // zapišemo nov orderId v bazo
              clientCountersCollection
                .add({
                  client: payload.client,
                  orderId: realNextOrderId,
                })
                .then(() => {
                  commit("getClientNextOrderId", realNextOrderId);
                  resolve();
                })
                .catch((error) => {
                  console.log(error);
                  reject();
                });
            });
          } else {
            querySnapshot.forEach((doc) => {
              realNextOrderId = doc.data().orderId;
              var getTimeStamp = firebase
                .functions()
                .httpsCallable("getTimeStamp");
              getTimeStamp({}).then((result) => {
                // preverimo, če je nov mesec in ustrezno nastavimo nov orderId
                if (
                  realNextOrderId.substring(0, 7) !==
                  moment(result).format("YYYY-MM")
                ) {
                  realNextOrderId = moment(result).format("YYYY-MM") + "-1";
                  // zapišemo nov orderId v bazo
                  clientCountersCollection
                    .doc(doc.id)
                    .update({
                      client: payload.client,
                      orderId: realNextOrderId,
                    })
                    .then(() => {
                      commit("getClientNextOrderId", realNextOrderId);
                      resolve();
                    })
                    .catch((error) => {
                      console.log(error);
                      reject();
                    });
                } else {
                  // če ni nov mesec, samo povečamo orderId
                  let tYear, tMonth, tNum;
                  tYear = realNextOrderId.substring(0, 4);
                  tMonth = realNextOrderId.substring(5, 7);
                  tNum = realNextOrderId.substring(8, realNextOrderId.length);
                  tNum = Number(tNum) + 1;
                  let tOrderId = tYear + "-" + tMonth + "-" + tNum;
                  // zapišemo nov orderId v bazo
                  clientCountersCollection
                    .doc(doc.id)
                    .update({
                      client: payload.client,
                      orderId: tOrderId,
                    })
                    .then(() => {
                      commit("getClientNextOrderId", tOrderId);
                      resolve();
                    })
                    .catch((error) => {
                      console.log(error);
                      reject();
                    });
                }
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
};

const mutations = {
  getClientNextOrderId(state, payload) {
    state.orderId = payload;
    //console.log("GET: " + state.orderId);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
